import React from 'react';
import { checkAll, checkMax, checkMoney, Container, Popup } from '@ivorobioff/shared';
import Saving from '../../../models/Saving';
import { Controller, useForm } from 'react-hook-form';
import { Subject } from 'rxjs';
import { TextField } from '@material-ui/core';
import SavingOperationService from '../../../services/SavingOperationService';

export interface BorrowPopupProps {
  saving: Saving;
  onClose: () => void;
  container: Container;
  onTransfer: (saving: Saving) => void;
}

interface FormData {
  amount: number;
}

export function BorrowPopup({ container, onClose, onTransfer, saving }: BorrowPopupProps) {
  const savingOperationService = container.get(SavingOperationService);

  const { control, handleSubmit } = useForm<FormData>({
    mode: 'onChange',
    defaultValues: {
      amount: saving.amount,
    }
  });

  return <Popup
    onHandle={() => {
      const subject = new Subject<boolean>();

      const done = (ok: boolean) => {
        subject.next(!ok);
        subject.complete();
      };

      handleSubmit(async ({ amount }) => {
        amount = Number(amount);
        
        const borrowed = await savingOperationService.borrow(saving, amount);

        onTransfer(borrowed.saving);
        done(true);
      }, () => done(false))();

      return subject.asObservable();
    }}
    onClose={onClose}
    submitButtonTitle="Transfer"
    cancelButtonTitle="Cancel"
    open={true}
    title="Borrow">

    <form>
      <Controller name="amount" control={control}
        rules={{
          validate: checkAll(checkMoney, (v) => checkMax(v, saving.amount)),
        }}
        render={({ field, fieldState: { invalid, error } }) =>
          <TextField label="Amount"
            fullWidth
            error={invalid}
            helperText={error?.message}
            {...field} />} />
    </form>
  </Popup>;
}